<template>
  <roe-error-message
    :field="design.auto_increase_annual_increase"
  >
    <roe-percent-input
      v-model="design.$model.auto_increase_annual_increase"
    ></roe-percent-input>
    <label class="input-label-inside">%</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoePercentInput from "@/components/_shared/inputs/PercentInput";
import { AutoIncreaseMixin } from "@/components/_shared/inputs/design/_mixins";
export default {
  name: "RoeAutoIncreaseAnnualPercentInput",
  components: { RoePercentInput, RoeErrorMessage },
  mixins: [AutoIncreaseMixin],
  props: {
    design: Object
  }
};
</script>
